import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import billpayRight from "../../../assets/billpay-right.png"

class BillPay extends Component {

  state = {}
  render() {
    return (
      <section>
        {/* <div className="container">
          <div className="row pt-4">
            <div className="col-12">
              <small>
                <Link to="/">
                  <FormattedMessage
                    id="breadcrumbs.home"
                    defaultMessage="Home"
                  />
                </Link>
              </small>{" "}
              /{" "}
              <small>
                <FormattedMessage
                  id="home.recharge-pay-bills"
                  defaultMessage="Recharge & Pay Bills"
                />
              </small>
            </div>
          </div>
        </div> */}
        <div className="billpay-banner">
          <div className="container">
          <div className="row align-items-center">
            <div className="col-6 head-margin">
            <h1 className="font-proxima-nova-bold">
                <FormattedMessage
                  id="home.recharge-pay-bills"
                  defaultMessage="Recharge & Pay Bills"
                  description="Recharge & Pay Bills"
                  values={{ what: "react-intl" }}
                />
              </h1>
              <h2>
                {this.props.heading_text.recharge.percentage}
              </h2>
             
            </div>
            <div className="col-6 d-flex justify-content-center">
              <img className="image" src={billpayRight} alt="billpay" />
            </div>
          </div>
          </div>
        </div>
        <div
          className="container container-fluid--home-section billslick"
          style={{ backgroundColor: "#FFF" }}
        >
          <div className="row">
            <div style={{ justifyContent: "flex-start" }} className="bill-pay-icon-container">
              {this.props.billpay.length > 0 &&
                this.props.billpay.map((item, index) => {
                  return (
                    <div className="billpay-page col-4 col-sm-4 col-md-3 col-lg-2 mb-3" key={"service-" + index}>
                      <Link to={`/bill-pay/${item.id}`}>
                        <div style={{ textAlign: "center" }}>
                          <div className="recharge-img-box">
                            <img
                              src={item.app_image_url}
                              className="bill-pay-service-icon-img mb-1 mb-md-2"
                              alt={item.name}
                            />
                          </div>
                          <p
                            className="bill-pay-service-icon-label mb-0"
                            style={{ textAlign: "center", color: "#666" }}
                          >
                            {item.name}
                          </p>
                        </div>
                      </Link>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    billpay: state.home.billpay,
    heading_text: state.home.heading_text,

  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillPay);